<template>
  <div class="grid h-full grid-cols-1 grid-rows-[auto_1fr]">
    <InfuseTabs>
      <InfuseRouteTab v-for="tab of tabs" :key="tab.name" :name="tab.name" :label="tab.label" :to="tab.to" />
    </InfuseTabs>

    <div class="h-full overflow-auto">
      <router-view :model="model" v-bind="$attrs" @reload-model="emit('reload-model')" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useFeatureStore } from '@infuse/cpms/shared/features/store';
import { InfuseRouteTab, InfuseTabs } from '@infuse/ui/components';
import { useParentRoute } from '@infuse/ui/services';
import { computed } from 'vue';

interface Emits {
  (e: 'reload-model'): void;

  (e: 'submit'): void;
}

const emit = defineEmits<Emits>();

defineProps<{ model?: any }>();

const featureStore = useFeatureStore();
const parentRoute = useParentRoute();

const tabRoutes = computed(() => parentRoute.value?.children.filter((child) => child.meta?.type === 'tab') ?? []);

const tabs = computed(() =>
  tabRoutes.value
    .filter((route) => !route.meta?.hidden)
    .filter((route) => !route.meta?.requiresFeature || featureStore.hasFeature(route.meta?.requiresFeature))
    .map((route) => ({
      name: route.name?.toString() ?? route.path,
      label: (route.meta?.label as string) ?? '',
      to: route.name ? { name: route.name } : route.path
    }))
);
</script>
